<template>
  <v-app>
    <SonyEnvironmentSystemBar />
    <v-main class="login-bg">
      <v-container class="fill-height">
        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import SonyEnvironmentSystemBar from "./SonyEnvironmentSystemBar.vue";

export default {
  name: "LayoutComingSoon",
  components: {
    SonyEnvironmentSystemBar
  }
};
</script>
